// Approximate directional sweep for the interactive preview. Export computes
// the exact offset geometry. Copies union alpha, so holes shrink rather than
// translating or scaling the entire design.
export function FillPreviewMask({ id, paths, fillRule, settings, scale, bounds }) {
  const expand = (settings.expand_mm ?? 0) * scale;
  const pull = Math.max(0, settings.pull_compensation_mm ?? 0.2) * scale;
  const angle = ((settings.angle ?? 45) * Math.PI) / 180;
  const steps = Math.max(1, Math.ceil(pull / (0.05 * scale)));
  const offsets = pull ? Array.from({ length: steps * 2 + 1 }, (_, i) => (i - steps) * pull / steps) : [0];
  return <>
    <mask id={`${id}-expand`} maskUnits="userSpaceOnUse" {...bounds}>
      <g fill="white" fillRule={fillRule} strokeLinejoin="round">
        {paths.map((d, i) => <path key={i} d={d} stroke={expand > 0 ? 'white' : 'none'} strokeWidth={Math.abs(expand) * 2} />)}
        {expand < 0 && paths.map((d, i) => <path key={`edge-${i}`} d={d} fill="none" stroke="black" strokeWidth={-expand * 2} />)}
      </g>
    </mask>
    <mask id={id} maskUnits="userSpaceOnUse" {...bounds}>
      {offsets.map((offset, i) => <g key={i} transform={`translate(${offset * Math.cos(angle)} ${offset * Math.sin(angle)})`}>
        <rect {...bounds} fill="white" mask={`url(#${id}-expand)`} />
      </g>)}
    </mask>
  </>;
}
